import {gsap} from "gsap";

window.addEventListener('load', () => {
    if (window.innerWidth < 768) return;

    const button = document.querySelector('.link-to-video');
    const circle = button?.querySelector<HTMLElement>('.link-to-video--circle');

    if (!button || !circle) return;

    const xTo = gsap.quickTo(circle, "x", {duration: 0.6, ease: "power3.out"});
    const yTo = gsap.quickTo(circle, "y", {duration: 0.6, ease: "power3.out"});

    window.addEventListener('mousemove', (e) => {
        const rect = circle.getBoundingClientRect();

        const centerX = rect.left + rect.width / 2 - (gsap.getProperty(circle, "x") as number);
        const centerY = rect.top + rect.height / 2 - (gsap.getProperty(circle, "y") as number);

        const disX = e.clientX - centerX;
        const disY = e.clientY - centerY;
        const distance = Math.sqrt(disX * disX + disY * disY);

        const maxDistance = 20;

        if (distance > 0) {
            const clampedDistance = Math.min(distance, maxDistance);

            const ratio = clampedDistance / distance;

            xTo(disX * ratio);
            yTo(disY * ratio);
        } else {
            xTo(0);
            yTo(0);
        }
    });

    window.addEventListener('mouseleave', () => {
        xTo(0);
        yTo(0);
    });
});